const faqs = [
  {
    q: '蛙漫漫画是免费的吗？',
    a: '是的，蛙漫漫画平台上所有漫画均免费在线阅读，无需充值、无需会员。我们坚持为读者提供零门槛的漫画阅读体验，让你随时随地畅享精彩内容。',
  },
  {
    q: '蛙漫漫画有哪些漫画类型？',
    a: '蛙漫漫画涵盖韩漫、日漫、国漫三大品类，内容覆盖恋爱、奇幻、热血、悬疑、耽美、搞笑、校园、都市、古风等数十种类型，满足不同读者的多样化阅读偏好。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '蛙漫漫画每日更新50部以上作品，热门连载漫画与原文同步更新，确保读者第一时间看到最新章节。同时每周有大量新作上线，内容库持续扩充。',
  },
  {
    q: '如何在手机上阅读漫画？',
    a: '你可以通过手机浏览器直接访问蛙漫漫画网页版，也可以下载蛙漫漫画APP（支持iOS和Android双平台）。APP提供更流畅的阅读体验，支持离线缓存和夜间模式。',
  },
  {
    q: '蛙漫漫画的漫画是否有版权？',
    a: '蛙漫漫画高度重视版权保护，所有上架漫画均获得正版授权或合规引进。我们尊重每一位原创作者的劳动成果，也呼吁读者支持正版漫画。',
  },
  {
    q: '遇到问题如何联系客服？',
    a: '你可以通过「投稿合作」板块中的联系方式与我们取得联系。对于内容反馈、功能建议或技术问题，发送邮件至对应邮箱，我们的团队会在24小时内回复处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
            你关心的，都在这里
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="p-5 rounded-2xl bg-background-50 border border-background-200/60"
            >
              <h3 className="text-sm font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}